<template>
    <v-container fluid class="main-container d-block pa-0">
        <div class="container-form">
            <DeviceHeaderMenu v-if="controllerData" :room-data="controllerData.hotel_room" no-settings @back="back"/>
            <v-flex class="controller-name" xs12 v-if="controllerData">
                {{controllerData.name}}
                <span class="main-text green-text ml-2" v-if="controllerData.online">online</span>
                <span class="main-text red-text ml-2" v-else>offline</span>
            </v-flex>
            <v-tabs fixed-tabs grow v-model="tabControllerSelected" class="tabs-title ma-0">
                <v-tab key="devices" href="#devices" class="left-tab">
                    Физические устройства
                </v-tab>
                <v-tab key="form" href="#form" class="right-tab">
                    Локальные правила
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabControllerSelected" class="tabs-container" v-if="controllerData.uid">
                <v-tab-item key="devices" value="devices">
                    <DebugControllerDevices :controllerId="controllerId" :controllerFullData="controllerData"/>
                </v-tab-item>
                <v-tab-item key="form" value="form">
                    <DebugControllerForm :controllerId="controllerId" :controllerFullData="controllerData"/>
                </v-tab-item>
            </v-tabs-items>
        </div>
        <ModalWaiting ref="modalWaiting" title="Загрузка данных"></ModalWaiting>
    </v-container>
</template>

<script>
import DeviceHeaderMenu from "@/components/DeviceHeaderMenu";
import ModalWaiting from "@/components/modals/ModalWaiting";
import DebugControllerForm from "@/components/controller/DebugControllerForm";
import DebugControllerDevices from "@/components/controller/DebugControllerDevices";

export default {
    name: "DebugControllerPage",
    components: {ModalWaiting, DeviceHeaderMenu, DebugControllerForm, DebugControllerDevices},
    data() {
        return {
            controllerId: null,
            controllerData: {},
            controllerNewData: {
                rules: [],
            },
            newRule: {
                input: null,
                rule_type: null,
                relays: [],
            },
            dryContacts: [],
            ruleTypes: [],
            relatedRelays: [],
            rules: {
                required: v => !!v || !!v && v.length > 0 || "Обязательное поле",
            },
            valid: true,
            tabControllerSelected: "devices",
        };
    },
    created() {
        this.controllerId = this.$route.params.id;
        if (this.$route.query.tab || this.$route.params.tab) {
            this.tabSelected = this.$route.query.tab || this.$route.params.tab;
        }
    },
    mounted() {
        if (this.controllerId) {
            this.getController();
        }
    },
    methods: {
        getController() {
            this.$refs.modalWaiting.open();
            this.controllerData = {};
            this.$http.get('/controllers/hotel-admin/controller/' + this.controllerId + '/')
                .then((response) => {
                    this.controllerData = response.data;
                    if (this.controllerData) {
                        this.controllerNewData.name = this.controllerData.name;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.$refs.modalWaiting.close();
                });
        },
        back() {
            if (this.controllerData && this.controllerData.hotel_room) {
                this.$router.push({name: "roompage", params: {id: this.controllerData.hotel_room.uid}});
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.main-container {
    height: 100%;
    text-align: center;

    .container-form {
        width: 100%;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        text-align: left;
        padding: 0 40px;

        &__row {
            width: 100%;
            display: inline-flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 2px;
            margin-bottom: 6px;

            > label {
                margin-left: 20px;
            }
        }

        &__rule {
            border: 1px solid #787878;
            border-radius: 12px;
            padding: 8px 12px;
            margin: 4px 0;
            width: 100%;
        }
    }
}

.controller-name {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: #130F26;
    margin-bottom: 20px;
}

.btn-grey.v-btn {
    display: inline-flex;
    width: auto;
    padding: 10px 16px;
    text-transform: none;
    margin-right: 10px;
}

.btn-light-grey {
    min-height: 60px;
    height: 60px;
}

.v-input.input-form-grey {
    width: 100%;
    max-width: 100%;
    position: relative;

    &::v-deep .v-input__control {
        display: flex;
        width: 100%;

        .v-input__slot {
            margin-bottom: 0;
            top: 14px;

            .v-text-field__slot,
            .v-select__slot .v-select__selections > div {
                max-height: 28px;
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .v-text-field__details {
            top: 12px;
            position: relative;
        }
    }
}

.connection-animate {
    animation: scale 1s infinite linear;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}
</style>